module.exports = __webpack_public_path__ + "media/application/images/svgs/phone-call-b98d10f50a6afb4a51d3fd6be4977803.svg";